import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { phoneOnly } from '../../common/ConstantsStyles';
import { getFeatureFlag } from '../../common/Utils';
import { useLagoon } from '../useLagoon';

export const useSnackcardViewAllCount = (count = 0) => {
  const mobileScreen = useMediaQuery(phoneOnly);
  const featureFlags: [{ key: string; active: boolean }] =
    useLagoon('feature-flags')();

  const isExpandViewAllEnabled: boolean = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_EXPANDED_SEARCH_RADIUS
  );

  let viewAllCount = '';
  let styleProps = {};
  let css = {};
  const viewAllColumnGap = {};
  if (isExpandViewAllEnabled) {
    viewAllCount = count > 200 ? '(200+)' : `(${count?.toString()})`;
    styleProps = {
      size: mobileScreen ? '$sm' : '$lg',
      iconSize: mobileScreen ? '$sm' : '$md',
    };
    css = {
      'abyss-link-root': {
        marginLeft: count > 0 ? 0 : '40px',
        lineHeight: mobileScreen ? '18px' : '24px',
      },
    };

    viewAllColumnGap['abyss-flex-root'] = {
      gap: '8px 40px',
      maxWidth: '1160px',
    };

    if (count > 0 && mobileScreen) {
      css = {
        'abyss-link-root': {
          '& .abyss-link-insert-element-after': {
            display: 'none',
          },
        },
      };
    }
  }

  return {
    viewAllCount,
    isExpandViewAllEnabled,
    styleProps,
    css,
    viewAllColumnGap,
  };
};
